"use client";
import { useState, useEffect } from "react";
import RouterLink from "@/components/ui/router-link";
import { cn } from "@/lib/utils";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import * as NProgress from "nprogress";

const tabs = [
  {
    title: {
      cn: "政策和规程",
      en: "Quality Policies & Procedures",
    },
    icon: "/icons/policies-procedures.webp",
    hash: "policies-procedures",
  },
  {
    title: {
      cn: "体系认证",
      en: "System Certifications",
    },
    icon: "/icons/certification-standards.webp",
    hash: "certification-standards",
  },
  {
    title: {
      cn: "可靠性",
      en: "Reliability",
    },
    icon: "/icons/reliability.webp",
    hash: "reliability",
  },
  {
    title: {
      cn: "环境信息",
      en: "Environmental Information",
    },
    icon: "/icons/environment.webp",
    hash: "environment",
  },
];

export default function TabsClient() {
  // 设置默认值为第一个 tab 的 hash
  const [currentHash, setCurrentHash] = useState("");

  const currentLocale = useCurrentLocale();

  // const router = useRouter();

  useEffect(() => {
    // 如果 URL 没有 hash，则设置为第一个 tab 的 hash

    const handleHashChange = () => {
      setCurrentHash(window.location.hash.slice(1));
    };

    if (!window.location.hash) {
      window.location.hash = `#${tabs[0]?.hash}`;
    } else {
      handleHashChange();
    }

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div className="z-20 h-[100px] w-full md:absolute md:bottom-0 md:left-0 md:right-0">
      <div className="pointer-events-none absolute left-0 right-0 top-0 hidden h-full bg-white bg-opacity-60 backdrop-blur-md md:block"></div>
      <div className="content_container relative z-10 h-full max-xl:px-6">
        <div className="grid h-full grid-cols-4">
          {tabs.map((item) => (
            <RouterLink
              className={cn(
                "flex cursor-pointer select-none flex-col items-center justify-center bg-transparent text-xs text-[#383838] transition-all duration-300 hover:text-primary md:text-base lg:text-lg xl:text-xl",
                {
                  "bg-white font-bold text-primary": currentHash === item.hash,
                }
              )}
              onClick={() => {
                if (currentHash === item.hash) return;

                NProgress.start();

                window.location.hash = `#${item.hash}`;
                NProgress.done();
              }}
              key={item.hash}>
              <div className="relative mb-2 h-10 w-10 md:hidden">
                <img
                  className="h-full w-full object-contain"
                  src={item.icon}
                  alt={currentLocale === "en" ? item.title?.en : item.title?.cn}
                />
              </div>

              <span>
                {currentLocale === "en" ? item.title?.en : item.title?.cn}
              </span>
            </RouterLink>
          ))}
        </div>
      </div>
    </div>
  );
}
